import React, { useState } from "react";
import "./LoginStyle.scss";
import LoginContent from "./LoginContent";
import LoginImage from "../../Assets/login.png";
import { Routes, Route ,useNavigate} from "react-router-dom";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import VerifyOtpForNewUser from "./VerifyOtpForNewUser";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = (props) => {
  const [isNewUserStateSent,] = useState(true);
  const navigate = useNavigate();
  const handleForgotPasswordClick = () => {
    navigate("/Login/forgot-password", { state: { isNewUserStateSent } });
  };
  const currentRoute = window.location.pathname;
  const handleSignInBack = () => {
    navigate("/login");// Navigate back to '/login-content'
    window.location.reload();// Reload the window to refresh the screen
  };

  const renderSignInBack = () => {
    if (
      currentRoute === "/Login/forgot-password" ||
      currentRoute === "/Login/reset-password" ||
      currentRoute === "/Login/otp-verification" ||
      currentRoute === "/Login/new-otp-verification" ||
      currentRoute === "/Login/set-password" ||
      currentRoute === "/Login/new-password" ||
      currentRoute === "/Login/verifyOtpnewUser"
    ) {
      return (
        <>
          <div className="flex mt-2 cursor-pointer" onClick={handleSignInBack}>
            <i
              className="pi pi-arrow-left ml-4 mt-1"
              style={{ fontSize: "1rem", color: "#1D2965" }}
            ></i>
            <div className="ml-2">Back to Sign in</div>
          </div>
        </>
      );
    }
    return null;
  };

  return (
    <div className="bg-white">
      <p
        className="font-medium ml-4 mb-4 font-semibold text-xl"
        style={{ color: "#E03581" }}
      >
        NHM Cockpit
      </p>
      <div className="-mt-2 h-2rem">{renderSignInBack()}</div>
      <div className="login-contain">
        <div className="grid">
          <div className=" col-12 md:col-6 lg:col-3 col-offset-1">
            <img
              src={LoginImage}
              style={{
                width: "27rem",
                height: "16rem",
                marginTop: "4.8rem",
                marginLeft: "1.3rem",
              }}
              alt=""
            ></img>
          </div>
          <div className="col-12 md:col-6 lg:col-3 col-offset-2 mt-3">
            <Routes>
              <Route
                index
                element={
                  <LoginContent
                    handleForgotPasswordClick={handleForgotPasswordClick}
                  />
                }
              />
              <Route
                path="/login-content/*"
                element={
                  <LoginContent
                    handleForgotPasswordClick={handleForgotPasswordClick}
                  />
                }
              />
              <Route
                path="/forgot-password"
                element={
                  <ForgotPassword
                    // handleResetPasswordClick={handleResetPasswordClick}
                  />
                }
              />
              {/* <Route path="/otp-verification" element={ <OTPVerification handleResetPasswordClick={handleResetPasswordClick}/> } /> */}
              <Route
                path="/reset-password"
                element={<ResetPassword
                // userFinalHandle={userFinalHandle}
                newUser={false}
                  />}
              />
              <Route
                path="/new-password"
                element={
                  <ForgotPassword
                    // handleSetPasswordClick={handleSetPasswordClick}
                    newUser={true}
                  />
                }
              />
              {/* <Route path="/new-otp-verification" element={ <OTPVerification handleSetPasswordClick={handleSetPasswordClick} newUser={true}/> } /> */}
              <Route
                path="/set-password"
                element={
                  <ResetPassword
                    // newUserFinalHandle={newUserFinalHandle}
                    newUser={true}
                  />
                }
              />
              <Route
                path="/verifyOtpnewUser"
                element={
                  <VerifyOtpForNewUser
                    // newUserFinalHandle={newUserFinalHandle}
                    newUser={true}
                  />
                }
              />
            </Routes>
          </div>
          <ToastContainer position="top-center"
        autoClose={1500}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light" />
        </div>
      </div>
    </div>
  );
};

export default Login;
